<template>
  <div>
    <b-overlay :show="show" no-wrap>
	</b-overlay>
  </div>
</template>

<script>
export default {
  data () {
    return {
      show: true
    }
  }
}
</script>